import { Select, MenuItem, InputLabel, FormControl } from '@mui/material'
import { DropDownProps, MenuItem as MenuItemType } from './DropDown.types'

export const DropDown = ({
  value,
  menuItems,
  label,
  className,
  onChange,
  name,
  defaultLabel,
  formControlSx,
  ...otherProps
}: DropDownProps) => {
  return (
    <FormControl
      sx={{
        width: '100%',
        height: '100%',
        ...formControlSx,
      }}
    >
      <Select
        value={value}
        name={name}
        onChange={onChange}
        variant="outlined"
        displayEmpty
        inputProps={{ 'aria-label': label, label }}
        className={className}
        {...otherProps}
      >
        {defaultLabel && (
          <MenuItem value="" disabled>
            <em>{defaultLabel}</em>
          </MenuItem>
        )}
        {menuItems.map((item: MenuItemType) => (
          <MenuItem key={item.value} value={item.value}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
